<template lang="pug">
  .avatar
    .wrapper
      img(:src="user.avatar")
    .nickname {{user.nickname}}

</template>

<script>
import gsap from 'gsap'

export default {
  name: 'Avatar',
  data() {
    return {
      user: {
        avatar:
          'https://tfs.alipayobjects.com/images/partner/T1EJxfXiRmXXXXXXXX',
        nickname: 'James',
      },
    }
  },
  methods: {
    animeIn(offsets) {
      gsap.fromTo(
        this.$el,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.7,
        }
      )
    },
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.avatar
  position: absolute
  bottom: 0
  right: pxToRem(40)
  width: pxToRem(84)
  //height: pxToRem(84)
  //background: aquamarine
  opacity: 0
  .wrapper
    line-height: 0
    width: pxToRem(84)
    height: pxToRem(84)
    border-radius: pxToRem(42)
    overflow: hidden
    img
      width: 100%
      object-fit: contain
  .nickname
    width: 100%
    font-size: pxToRem(20)
</style>
